import React, { useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  TextField,
  Box,
  FormHelperText
} from '@mui/material'
import { useFormik } from 'formik'
import MyButton from '../../ui/MyButton'
import { Rating } from '@mui/material';
import { Star } from '@mui/icons-material'
import * as yup from 'yup'

const EditReview = ({
  openDialog,
  handleCloseDialog,
  review,
  updateReviewById,
  setOpenDialog,
}) => {
  const [hover, setHover] = useState(-1)

  const initialValues = {
    content: review.content,
    rating: review.rating,
    teacher: review.teacher,
    orderId: review.order
  }

  const validationSchema = yup.object({
    rating: yup.number().required('Vui lòng chọn sao'),
    content: yup.string().required('Vui lòng điền nội dung')
  })

  const handleSubmit = (values) => {
    updateReviewById(review._id, values)
    setOpenDialog(false)
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit
  })

  const labels = {
    0.5: 'Không hiệu quả',
    1: 'Không hiệu quả+',
    1.5: 'Kém',
    2: 'Kém+',
    2.5: 'Ổn',
    3: 'Ổn+',
    3.5: 'Tốt',
    4: 'Tốt+',
    4.5: 'Xuất sắc',
    5: 'Xuất sắc+'
  }

  return (
    <Dialog open={openDialog} onClose={handleCloseDialog}>
      <DialogTitle style={{ textAlign: 'center' }}>Sửa nhận xét</DialogTitle>
      <DialogContent>
        <form onSubmit={formik.handleSubmit}>
          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={2}
          >
            <Grid item>
              <Box
                sx={{
                  width: 200,
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Rating
                  name="rating"
                  value={formik.values.rating}
                  precision={0.5}
                  onChange={formik.handleChange}
                  onChangeActive={(event, newHover) => {
                    setHover(newHover);
                  }}
                  emptyIcon={<Star style={{ opacity: 0.55 }} fontSize="inherit" />}
                />
                {formik.values.rating !== null && (
                  <Box sx={{ ml: 2 }}>{labels[hover !== -1 ? hover : formik.values.rating]}</Box>
                )}
              </Box>

              <FormHelperText error={formik.touched.rating && Boolean(formik.errors.rating)}>{formik.errors.rating}</FormHelperText>
            </Grid>

            <Grid item style={{ minWidth: '90%' }}>
              <TextField
                name="content"
                label="Nội dung"
                multiline
                rows={5}
                onChange={formik.handleChange}
                value={formik.values.content}
                error={formik.touched.content && Boolean(formik.errors.content)}
                helperText={formik.touched.content && formik.errors.content}
              />
            </Grid>

            <Grid
              item
              container
              justifyContent="center"
              align="center"
              spacing={1}
            >
              <Grid item>
                <MyButton onClick={handleCloseDialog}>Đóng</MyButton>
              </Grid>

              <Grid item style={{ paddingBottom: '1em' }}>
                <MyButton type="submit">Lưu lại</MyButton>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
}

export default EditReview
